import React from "react";
import uuid from "uuid";
import ChooseBottle from "./ChooseBottle.jsx";
import ChooseSize from "./ChooseSize.jsx";
import Customize from "./Customize.jsx";
import Finalize from "./Finalize.jsx";
import { Popover, ChooseText, ChooseLogo, ChooseColor } from "./Popover.jsx";
import { colors } from "./constants.js";
import Alert from "react-s-alert";
import $ from "jquery";
import "react-s-alert/dist/s-alert-default.css";
import "react-s-alert/dist/s-alert-css-effects/slide.css";
import Modal from "./modal";
import "./App.css";

const PopoverComponent = ({
  popoverState,
  selectColor,
  logo,
  updateLogo,
  toggleLogoPopover,
  text,
  updateText,
  toggleTextPopover
}) => {
  if (popoverState === "color")
    return <ChooseColor selectColor={selectColor} />;
  if (popoverState === "logo")
    return (
      <ChooseLogo
        updateLogo={updateLogo}
        logo={logo}
        togglePopover={toggleLogoPopover}
      />
    );
  if (popoverState === "text")
    return (
      <ChooseText
        text={text}
        updateText={updateText}
        togglePopover={toggleTextPopover}
      />
    );
  return <div />;
};

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this._getLocation.apply(this);
    this.state = {
      type: "sportMixer",
      size: "28oz",
      color: colors.White,
      quantity: 0,
      finalize: false,
      popoverState: null,
      selectedObject: null,
      logo: null,
      text: null,
      bottleImage: null,
      location: {},
      showModal: false,
      topObject: "logo",
      formName: ""
    };
  }
  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal
    });
  };
  _selectBottle(bottle) {
    this.setState({
      type: bottle
    });
  }
  _getLocation() {
    $.get("https://freegeoip.net/json/").then(location => {
      this.setState({ location });
    });
  }
  _selectSize(size) {
    this.setState({
      size: size
    });
  }
  _restart() {
    this.setState({
      size: "28oz",
      type: null,
      finalize: false,
      popoverState: null,
      quantity: 0
    });
  }
  _customize() {
    this.setState({
      finalize: false,
      popoverState: null,
      quantity: 0
    });
  }

  _selectColor = (part, color) => {
    this.setState({
      color: Object.assign({}, this.state.color, {
        [part]: colors[color][part]
      })
    });
  };
  _updateQuantity(quantity) {
    this.setState({
      quantity: Math.min(parseInt(quantity, 10), 240)
    });
  }
  _toggleColorPopover = () => {
    if (this.state.popoverState !== "color") {
      this.setState({
        popoverState: "color"
      });
    } else {
      this.setState({
        popoverState: null
      });
    }
  };
  _toggleLogoPopover = () => {
    if (this.state.popoverState !== "logo") {
      this.setState({
        popoverState: "logo"
      });
    } else {
      this.setState({
        popoverState: null
      });
    }
  };
  _toggleTextPopover = () => {
    if (this.state.popoverState !== "text") {
      this.setState({
        popoverState: "text"
      });
    } else {
      this.setState({
        popoverState: null
      });
    }
  };
  _clearPopover = () => {
    this.setState({
      popoverState: null
    });
  };
  _clearSelection() {
    this.setState({
      selectedObject: null
    });
  }
  _updateLogo = (logo, selectedObject) => {
    this.setState({
      logo: logo,
      selectedObject: selectedObject
    });
  };
  _updateText = (text, selectedObject) => {
    this.setState({
      text: text,
      selectedObject: selectedObject
    });
  };
  _finalizeBottle(artImage, bottleImage, svg, json) {
    if (this.state.size && this.state.type) {
      this.setState({
        finalize: true,
        popoverState: null,
        bottleImage: artImage,
        fullImage: bottleImage,
        jsonData: json,
        svgData: svg
      });
    }
  }
  _addToCart = ({ formName, formEmail }) => {
    this.toggleModal();

    const formdata = {};
    formdata.key = uuid.v4();
    formdata.name = formName;
    formdata.email = formEmail;
    formdata.ip = this.state.location.ip;
    formdata.file = this.state.fullImage;
    formdata.svg = this.state.svgData;
    formdata.color = JSON.stringify(this.state.color);
    formdata.salesRep = window.location.search.replace(/\?rep=/gi,'');
    $.ajax({
      url:
        "https://06q4mk26ql.execute-api.us-east-1.amazonaws.com/Prod/apples-s3-proxy",
      data: JSON.stringify(formdata),
      contentType: "text/plain",
      type: "POST",
      error: function() {
        Alert.error(
          "There was an error submitting your design. Please try again."
        );
      }
    }).done(() => {
      Alert.success(
        "Your design has been successfully submitted. A copy of your submission will be emailed to you."
      );
    });
  };
  render() {
    return (
      <div className="opals">
        <div className="text-center designer-head">Custom Bottle Creator</div>
        <div className="container">
          {this.state.finalize && (
            <Finalize
              color={this.state.color}
              type={this.state.type}
              size={this.state.size}
              logo={this.state.logo}
              quantity={this.state.quantity}
              customize={this._customize.bind(this)}
              submitBottle={this.toggleModal.bind(this)}
              updateQuantity={this._updateQuantity.bind(this)}
              bottleImage={this.state.bottleImage}
              fullImage={this.state.fullImage}
            />
          )}
          {!this.state.finalize &&
            this.state.type &&
            this.state.size && (
              <Customize
                toggleColorPopover={this._toggleColorPopover.bind(this)}
                toggleLogoPopover={this._toggleLogoPopover.bind(this)}
                toggleTextPopover={this._toggleTextPopover.bind(this)}
                finalizeBottle={this._finalizeBottle.bind(this)}
                color={this.state.color}
                jsonData={this.state.jsonData}
                updateLogo={this._updateLogo.bind(this)}
                removeLogo={this._updateLogo.bind(this, {})}
                updateText={this._updateText.bind(this)}
                removeText={this._updateText.bind(this, null)}
              />
            )}
          {!this.state.finalize &&
            this.state.type &&
            !this.state.size && (
              <ChooseSize
                color={this.state.color}
                selectSize={this._selectSize.bind(this)}
                type={this.state.type}
              />
            )}
          {!this.state.finalize &&
            !this.state.type && (
              <ChooseBottle
                selectBottles={this._selectBottle.bind(this)}
                color={this.state.color}
              />
            )}
        </div>
        {this.state.popoverState && (
          <div onClick={this._clearPopover} className="popoverCover" />
        )}
        <div className={`${this.state.popoverState && "shown"} popoverHolder`}>
          {this.state.popoverState && (
            <Popover>
              <PopoverComponent
                popoverState={this.state.popoverState}
                selectColor={this._selectColor}
                logo={this.state.logo}
                updateLogo={this._updateLogo}
                toggleLogoPopover={this._toggleLogoPopover}
                text={this.state.text}
                updateText={this._updateText}
                toggleTextPopover={this._toggleTextPopover}
              />
            </Popover>
          )}
        </div>
        <Modal
          showModal={this.state.showModal}
          toggleModal={this.toggleModal}
          addToCart={this._addToCart}
        />
        <Alert stack={{ limit: 3 }} effect="slide" timeout={5000} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js